import {
  getNotificationHealthIssueDetails,
  NotificationHealthIssueCode,
} from "../types/notification-health.entity";

type Props = {
  issueCode: NotificationHealthIssueCode;
};

export const NotificationHealthIssueBadge = ({ issueCode }: Props) => {
  const issue = getNotificationHealthIssueDetails(issueCode);

  return (
    <span
      className={`inline-flex max-w-full flex-wrap items-center gap-x-1 rounded-full border px-2 py-1 text-[10px] font-semibold leading-4 ${issue.className}`}
      title={issue.description}
    >
      <span>{issue.label}</span>
      {issue.fieldName && (
        <code className="font-mono text-[9px] font-medium">({issue.fieldName})</code>
      )}
    </span>
  );
};
